<div class="card card-custom gutter-b card-fit" data-card="true" id="kt_card_1">
    <div class="card-header">
        <div class="card-title">
            <h3 class="card-label">Assoc. People</h3>
        </div>
        <div class="card-toolbar"> 

            <button type="button" class="btn btn-sm btn-primary font-weight-bold" (click)="add()">
                <!--begin::Svg Icon | path: icons/duotune/general/gen031.svg-->
                <i class="fas fa-plus icon-sm"></i>Add Assoc
            </button>
        </div>
    </div>
    <div class="card-body  mt-0 py-0 px-5">
        <span *ngIf="petService.pet_associates.length === 0">No information available</span>
        <div class="table-responsive h-500px">
            <table class="table">
                <thead>
                    <tr>
                        <th class="p-0 min-w-150px">Client Name</th>
                        <th class="p-0 min-w-120px">Authority</th>
                        <th class="p-0 min-w-100px">Financial %</th>
                        <th class="p-0 min-w-100px"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of petService.pet_associates">

                        <td class="pl-0">
                            <span class="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg"
                                (click)="edit(item)">
                                {{ item.first_name }} {{ item.last_name }}
                            </span>
                            
                        </td>
                        <td><p>{{ item.authority_desc | uppercase }}</p></td>
                        <td class="">
                            <span class="text-muted font-weight-bold">
                                {{ item.associate_ownership }}%
                            </span>
                        </td>
                        <td class="text-right pr-0">
                            <button type="button" class="btn btn-icon btn-secondary btn-sm m-1" (click)="edit(item)">
                                <i class="la la-pen"></i>
                            </button>
                            <button type="button" class="btn btn-icon btn-secondary btn-sm btn-hover-danger m-1"
                                (click)="trash(item)">
                                <i class="la la-trash"></i>
                            </button>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>
    </div>
</div>